import { CHANNELS } from './channelConfig';

export default function SendConfirmModal({
  isOpen,
  onClose,
  onConfirm,
  form,
  submitting,
  audienceHint,
  recipientEstimate,
  maxRecipients,
  platformMode = false,
}) {
  if (!isOpen) return null;

  const channelLabels = (form.channels || [])
    .map((id) => CHANNELS.find((c) => c.id === id)?.label || id)
    .join(' + ');

  const quotaParts = [];
  if (!platformMode) {
    if (form.channels?.includes('EMAIL')) quotaParts.push('1 quota email');
    if (form.channels?.includes('IN_APP')) quotaParts.push('1 quota In-App');
  }
  const quotaLabel = platformMode
    ? 'hors quota commerçant (plateforme Clickorico)'
    : quotaParts.length
      ? quotaParts.join(' + ')
      : '1 quota In-App';

  const destLabel =
    typeof recipientEstimate === 'number'
      ? `${recipientEstimate} destinataire${recipientEstimate > 1 ? 's' : ''} (estimation)`
      : audienceHint || 'Destinataires : calculés à l’envoi côté serveur';

  return (
    <div className="fixed inset-0 z-[6000] overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen px-4 py-8">
        <div
          className="fixed inset-0 bg-gray-500 bg-opacity-75"
          onClick={submitting ? undefined : onClose}
          aria-hidden
        />
        <div className="relative bg-white rounded-lg shadow-xl w-full max-w-md overflow-hidden">
          <div className="px-6 py-4 border-b border-gray-100">
            <h3 className="text-lg font-semibold text-gray-900">Confirmer l’envoi</h3>
          </div>
          <div className="px-6 py-5 space-y-3 text-sm text-gray-700">
            <p>
              Vous allez envoyer{' '}
              {platformMode ? 'la communication plateforme' : 'la campagne'}{' '}
              <strong>{form.title || form.subject || 'sans titre'}</strong>.
            </p>
            <ul className="list-disc pl-5 space-y-1 text-gray-600">
              <li>Canal{form.channels?.length > 1 ? 'x' : ''} : <strong>{channelLabels || 'In-App'}</strong></li>
              {form.imageUrl ? <li>Image : <strong>oui</strong></li> : null}
              {form.ctaLabel?.trim() && form.ctaUrl?.trim() ? (
                <li>
                  Bouton : <strong>{form.ctaLabel.trim()}</strong>
                </li>
              ) : null}
              <li>
                Destinataires : <strong>{destLabel}</strong>
                {!platformMode && typeof maxRecipients === 'number' && (
                  <span className="text-gray-500">
                    {' '}
                    — jusqu’à {maxRecipients} destinataires disponibles
                  </span>
                )}
              </li>
              <li>
                Quota : <strong>{quotaLabel}</strong>
              </li>
            </ul>
            <p className="text-xs text-gray-500">
              L’envoi est définitif. Les emails transactionnels (commandes, résas) ne sont pas
              impactés.
            </p>
          </div>
          <div className="px-6 py-4 border-t border-gray-100 flex justify-end gap-3">
            <button type="button" className="btn-secondary" onClick={onClose} disabled={submitting}>
              Retour
            </button>
            <button
              type="button"
              className="btn-primary"
              onClick={onConfirm}
              disabled={submitting}
            >
              {submitting ? 'Envoi en cours…' : 'Envoyer maintenant'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
